Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'product-details-add-ons', function (envelope) {
        var $context = envelope.message.data.context,
            $control = $('.x-product-details-add-ons', $context);

        if ($control.length < 1)
            return;

        $.each($control, function (i, control) {

            $(".js-checkbox-add-on", control).change(function () {
                updateProductPrice();
            });

            // toggle button for add-ons list
            $('.js-toggle-button', control).on('click', function (e) {
                e.preventDefault();

                var $this = $(this);
                var $lists = $(control).find('ul.add-ons-list');

                if ($lists.length < 1) return;

                var isVisible = $lists.first().is(':visible');

                if (isVisible) {
                    $lists.slideUp();
                    $this.removeClass('expanded');
                } else {
                    $lists.slideDown();
                    $this.addClass('expanded');
                }
            });

        });

        // helper to update total price in product details when addons change
        function updateProductPrice() {
            var $currentPrice = $('.js-current-price', $context);
            var $currentContainer = $currentPrice.closest('.current-price-container');
            var $totalPrice = $('.js-total-price', $context);
            var $totalContainer = $totalPrice.closest('.total-price-container');
            var basePrice = parseFloat($currentPrice.data('current-price')) || 0;
            var addOnsTotalPrice = 0;

            $('.js-checkbox-add-on:checked', $context).each(function () {
                var $checkedAddOn = $(this).closest('.add-on-item').find('.current-price[data-current-price]').first();
                addOnsTotalPrice += parseFloat($checkedAddOn.data('current-price')) || 0;
            });

            var totalPrice = basePrice + addOnsTotalPrice;
            var numberOfDigits = LhApp.Context.Currency.NumberOfDigits;
            var decimalSeparator = LhApp.Context.Currency.DecimalSeparator;
            var currencySymbol = decodeEntities(LhApp.Context.Currency.Symbol);
            var priceParts = totalPrice.toFixed(numberOfDigits).split('.');
            priceParts[0] = priceParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            var formattedTotalPrice = priceParts.join(decimalSeparator);
            var isCurrencyFirst = $.trim($currentPrice.text()).indexOf(currencySymbol) === 0;
            var totalPriceText = isCurrencyFirst
                ? currencySymbol + ' ' + formattedTotalPrice
                : formattedTotalPrice + ' ' + currencySymbol;

            $context.attr('data-total-price', totalPrice.toFixed(numberOfDigits));
            $totalPrice.attr('data-total-price', totalPrice.toFixed(numberOfDigits));
            $totalPrice.html(totalPriceText);

            if (addOnsTotalPrice > 0) {
                $currentContainer.addClass('hidden');
                $totalContainer.removeClass('hidden');
            } else {
                $currentContainer.removeClass('hidden');
                $totalContainer.addClass('hidden');
            }

            $totalPrice.removeClass('price-formatted');
            formatPrices($context);
        }

    });
    
});
